export const Formatter = new Intl.NumberFormat("en-US", { signDisplay: "never" });